




































import { Component, Vue, Prop } from 'vue-property-decorator'
// import orderList from './orderList.vue'
@Component({
  // components: { orderList },
  name: 'cuisineview',
})
export default class extends Vue {
  @Prop() private dishesData!: any
}
